/**
 * Shared API configuration and utilities
 */

// Re-export API_URLS from config (environment-aware)
export { API_URLS } from "@solomon-apps/config";

/**
 * Default query options for React Query
 */
export const DEFAULT_QUERY_OPTIONS = {
    /** Data is fresh for 5 minutes */
    staleTime: 5 * 60 * 1000,
    /** Refetch every 5 minutes */
    refetchInterval: 5 * 60 * 1000,
    /** Don't refetch on window focus */
    refetchOnWindowFocus: false,
    /** Refetch on reconnect */
    refetchOnReconnect: true,
    /** Retry failed requests twice */
    retry: 2
} as const;

/**
 * Fetch JSON from URL with error handling
 */
export async function fetchJson<T>(url: string, signal?: AbortSignal): Promise<T> {
    const response = await fetch(url, { signal });

    if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    return response.json() as Promise<T>;
}

/**
 * Fetch JSON with custom error handling for 404 (not found)
 */
export async function fetchJsonWithNotFound<T>(url: string, notFoundMessage: string, signal?: AbortSignal): Promise<T> {
    const response = await fetch(url, { signal });

    if (!response.ok) {
        if (response.status === 404) {
            throw new Error(notFoundMessage);
        }
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    return response.json() as Promise<T>;
}
